// The reason we define this polyfill is that `Set` defined by core-js has
// many nested function calls, so it occurred an error of out of stack at IE11.
// @see https://github.com/zloirock/core-js/blob/master/modules/_collection.js
export function MySet (iterable) {
  const array = []

  const methods = {
    has (value) {
      return !!this.find(v => v === value)
    },

    add (value) {
      if (this.has(value)) return
      this.push(value)
      this.size = this.length
    },

    delete (value) {
      const i = this.indexOf(value)
      if (i < 0) return
      this.splice(i, 1)
      this.size = this.length
    },

    clear () {
      this.splice(0, this.length)
      this.size = this.length
    },
  }

  array.has = methods.has
  array.add = methods.add
  array.delete = methods.delete
  array.clear = methods.clear

  Array.from(iterable).forEach((v) => { array.add(v) })

  return array
}

export default { MySet }



// WEBPACK FOOTER //
// ./src/libs/polyfill.js